export default "/images/1cad309b3e2deaa4e22776ff883f1dec.avif";